import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Payments from '../../../../api/api-payments';
import { normalizeContracts } from '../../app-bookings-request/forms/bookingUtil';
import UpdatePaymentMain from '../../app-bookings-update-payment/update-payment-main';
import { PageSpinner } from '../../shared-components/decorators/spinner';
import { initAuth } from '../actions/auth';
import { fetchContracts } from '../actions/contracts';
import { fetchEnvWeb } from '../actions/env';

export class UpdatePaymentContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paymentInfo: null,
      selectedPayment: null
    };

    this.fetchCardData = this.fetchCardData.bind(this);
    this.shouldRedirect = this.shouldRedirect.bind(this);
  }

  componentDidMount() {
    const {
      dispatch,
      accessToken,
      profile,
      routeParams,
      env,
      normalizedContracts,
      router
    } = this.props;

    if (!accessToken) {
      window.location.href = '/';
      return;
    }

    if (
      !isEmpty(normalizedContracts?.masterContract) &&
      this.shouldRedirect()
    ) {
      router.push(`/inbox/${routeParams?.bookingID || ''}`);
    }

    if (isEmpty(profile?.data)) {
      dispatch(initAuth(accessToken));
    }
    const authInitialized = !!profile?.SSOid;
    if (authInitialized) {
      this.fetchCardData(profile.SSOid);
    }

    const bookingId = routeParams?.bookingID;
    dispatch(fetchContracts(bookingId, accessToken));
    if (isEmpty(env?.web)) {
      dispatch(fetchEnvWeb());
    }
  }

  componentDidUpdate(prevProps) {
    const { accessToken, normalizedContracts, profile, router, routeParams } =
      this.props;
    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = '/';
    }
    const contractsFetched =
      isEmpty(prevProps.normalizedContracts) && !isEmpty(normalizedContracts);
    if (contractsFetched && this.shouldRedirect()) {
      router.push(`/inbox/${routeParams?.bookingID || ''}`);
    }

    const authInitialized = !prevProps?.profile?.SSOid && profile?.SSOid;
    if (authInitialized) {
      this.fetchCardData(profile.SSOid);
    }
  }

  shouldRedirect() {
    const { normalizedContracts } = this.props;
    const { masterContract } = normalizedContracts;
    if (!masterContract) {
      return true;
    }

    const isSplitPaymentBooking = masterContract.split_payment_checkout;
    const hasUncapturedPayment = masterContract.balance_split_payments;
    const settleBalanceRequired =
      masterContract.state === 'SETTLE_BALANCE_REQUIRED' ||
      masterContract.state === 'GUEST_SETTLE_BALANCE_NO_AUTH';

    // page only available for accepted split payment bookings with an upcoming or a failed payment
    if (isSplitPaymentBooking) {
      return !hasUncapturedPayment && !settleBalanceRequired;
    }

    return true;
  }

  fetchCardData(SSOid) {
    const { accessToken } = this.props;
    Payments.getCustomerData(SSOid, accessToken, (res) => {
      let paymentInfo = [];
      if (res?.data?.length) {
        paymentInfo = res.data;
      }
      this.setState({ paymentInfo });
    });
  }

  render() {
    const { normalizedContracts } = this.props;
    const { paymentInfo } = this.state;

    return !normalizedContracts?.masterContract || !paymentInfo ? (
      <PageSpinner additionalStyle='gray' />
    ) : (
      <UpdatePaymentMain {...this.props} paymentInfo={paymentInfo} />
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, contract, profile, env } = state;
  const { accessToken } = auth;
  let normalizedContracts;
  if (contract?.contracts) {
    normalizedContracts = normalizeContracts(
      contract.contracts,
      contract.contracts.find((c) => c.type === 'SPACE_RENTAL')
    );
  }

  return {
    accessToken,
    normalizedContracts,
    profile,
    env,
    outstandingBalance: contract.outstanding_balance
  };
};

export default injectIntl(
  connect(mapStateToProps)(UpdatePaymentContainer)
);
